<template>
    <div class="workflowrefineFilters" v-if="workflowrefines.length">
        <div class="title">{{ trans("Filter op") }}:</div>
        <template v-for="(item, index) in workflowrefines">
            <template v-if="item.field_type === 'DateField'">
                <div class="dateFilter">
                    <label>{{ trans("%s van", item.label) }}:</label>
                    <DateField
                        :name="`${item.workflowpropertyfield_id}_from`"
                        :label="item.label"
                        :value="value(item, '>=')"
                        :required="false"
                        :readonly="false"
                        :show_label="false"
                        :editing="true"
                        @valueChange="handleDateFilter(`${item.workflowpropertyfield_id}_from`, item)"
                    />
                </div>
                <div class="dateFilter" v-if="item.field_range === 'Y'">
                    <label>{{ trans("%s tot", item.label) }}:</label>
                    <DateField
                        :name="`${item.workflowpropertyfield_id}_to`"
                        :label="item.label"
                        :value="value(item, '<=')"
                        :required="false"
                        :readonly="false"
                        :show_label="false"
                        :editing="true"
                        @valueChange="handleDateFilter(`${item.workflowpropertyfield_id}_to`, item)"
                    />
                </div>
            </template>
            <template v-else>
                <div class="dropdown" :ref="el => { el && (dropdownRefs[index] = el) }"><!-- :class="{ zero : (total(componentData.totals[item.workflowpropertyfield_id]) === 0) }" -->
                    <button class="more white dropdown-toggle" type="button" @click.prevent="handleDropdownClick(index)">
                        <span class="title">{{ item.label }}</span>
                    </button>
                    <div class="dropdown-menu right" :class="{show: isDropdownActive(index), hasChecked: hasChecked(item) }">
                        <div class="input-group" v-if="item?.extra?.options.length > 5">
                            <input class="input form-control" :placeholder="trans('Zoeken')" type="text" v-model="visualSearch" ref="searchInputRef">
                            <div class="input-group-addon input-group-append" v-if="hasChecked(item)">
                                <button type="button" class="more small" @click.prevent="resetSelection(item)">
                                    <span class="title">{{ trans("Selectie verwijderen") }}</span>
                                </button>
                            </div>
                            <div class="input-group-addon input-group-append">
                                <button type="button" class="btn">
                                    <Icon name="search" />
                                </button>
                            </div>
                        </div>
                        <div class="items">
                        <ul class="block-grid one-up">
                            <li v-for="(value, key) in visualFilter(item?.extra?.options)">
                                <label class="dropdown-item" :class="{ checked: checked(item, value) }" @click="handleClick($event, item, value)"> <!-- zero: (componentData.totals[item.workflowpropertyfield_id]?.[value.id] === 0)  -->
                                    <input
                                        :type="inputType(item)"
                                        :value="value.id"
                                        @chandle.prevent="handleChange(item.workflowpropertyfield_id, value.id)"
                                        v-model="filterValues[item.workflowpropertyfield_id]"
                                    />
                                    <span class="label">
                                        <span class="title">{{ value.label }}</span>
                                    </span>
                                </label>
                            </li>
                        </ul>
                        <div class="empty" v-if="!visualFilter(item?.extra?.options)?.length">
                            {{ trans("Geen resultaten gevonden.") }} <u v-if="item?.extra?.options.length" class="useHand" @click.stop="resetSearch">{{ trans("Reset") }}</u>
                        </div>
                        </div>
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import {defineComponent, reactive, inject, watch, computed, ref, onMounted, onUnmounted, provide} from "vue";
import { useRouter, useRoute } from "vue-router";

import { env, config, apiHostname } from "config";
import trans from "helpers/_translation";
import { debounce } from 'lodash-es'; // if you're using lodash-es

// Helpers
import { getDataWithoutLimit } from "helpers/_api";
import { getUrlWithQueryItemReplaced, getQuery } from "helpers/_structure";
import { resolveData } from "helpers/_data";

import DateField from "components/elements/DateField.vue";

import { generalFilters } from "store/filters";
import { workflowStore, workflowpropertyById, getWorkflowphasesByBoardId } from "store/workflow";
import { company_id } from "store/company";

import Icon from "components/icon";

export default defineComponent({
    name: "filters",
    props: {
        workflowboard_id: {
            type: String,
            required: true
        }
    },
    components: {
        DateField,
        Icon
    },
    setup(props) {

        const route = useRoute();
        const router = useRouter();

        const viewData = inject("viewData");
        const appData = inject("appData");

        const search = inject("search");
        const filterValues = reactive({});

        const searchInputRef = ref();
        const visualSearch = ref("");

        const workflowboard_id = computed(() => props.workflowboard_id ?? viewData.workflowboard_id);

        const formRef = ref(null);

        const componentData = reactive({
            workflowrefines_init: false,
            workflowrefines: [],
            totals: {}
        });

        const dropdownRefs = [];
        const activeDropdown = ref(null);

        const catchOutsideClick = (e) => {
            const dropdown = dropdownRefs[activeDropdown.value];
            // When user clicks outside of the menu — close the menu
            if (dropdown && dropdown !== e.target && !dropdown.contains(e.target)) return true;
            return false;
        };
        const closeListener = (e) => {
            let wasOutside = dropdownRefs.some(dropdownRef => {
                return catchOutsideClick(e, dropdownRef)
            });
            if (wasOutside) {
                activeDropdown.value = null;
            }
        };
        const handleDropdownClick = (index) => {
            if (activeDropdown.value !== index) {
                activeDropdown.value = index;

                setTimeout(() => {
                    searchInputRef.value && searchInputRef.value?.[0]?.focus();
                }, 200);
            } else {
                activeDropdown.value = null;
            }
        };
        window.addEventListener('click', closeListener);

        const isDropdownActive = (index) => {
            return computed(() => {
                return activeDropdown.value === index;
            }).value;
        };

        const inputType = (item) => {
            return computed(() => {
                return (item.field_type === "CheckboxField") ? "checkbox" : "radio";
            }).value;
        };


        const defineFilter = (workflowpropertyfield, values, key) => {
            let operator = "IN";

            if (workflowpropertyfield.type === "DateField") {
                operator = key.endsWith("_from") ? ">=" : "<=";
                values = values[0];
                if (!values || values === "Invalid date") return;
            }

            return [
                "StudioIbizz\\Workflowproperty\\Filters\\Workflowproperty",
                {
                    "c": workflowpropertyfield.name,
                    "v": values.map(a => `${a}`),
                    "o": operator
                }
            ];
        };
        const handleFilter = () => {
            const newFilters = [];
            for (const [key, selectedValues] of Object.entries(filterValues)) {
                const tmpKey = key.replace(/_from|_to/, "");
                const item = componentData.workflowrefines.find(a => `${a.workflowpropertyfield_id}` === `${tmpKey}`);
                const workflowpropertyfield = item?.extra?.workflowpropertyfield;
                if (!selectedValues) continue;
                const tmpValues = Array.isArray(selectedValues) ? selectedValues : [selectedValues];
                if (!workflowpropertyfield || !tmpValues.length) continue;
                const filter = defineFilter(workflowpropertyfield, tmpValues, key);
                if (filter) newFilters.push(filter);
            }
            generalFilters.workflowrefine = newFilters;
            viewData.overview_ticker += 1;
        };

        const filter = (data, mock_name = null, mock_value = null) => {
            let result = [...data];
            const searchQuery = search.value;
            if (searchQuery) {
                const searchLower = searchQuery.toLowerCase();
                result = [];
                data.forEach(item => {
                    // Check title and workflowproperties for any matches
                    if (item.title && item.title.toLowerCase().includes(searchLower)) {
                        result.push(item);
                    } else {
                        item.extra.workflowproperties.some(a => {
                            return a.value && (typeof a.value === "string") && a.value.toLowerCase().includes(searchLower);
                        }) && result.push(item);
                    }
                });
            }

            const tmpFilters = {};
            const tmpDateFilters = {};
            generalFilters?.workflowrefine?.forEach(workflowfilter => {
                if (workflowfilter[1].o === "IN") {
                    tmpFilters[workflowfilter[1].c] = [...workflowfilter[1].v];
                } else {
                    if (!(workflowfilter[1].c in tmpDateFilters)) {
                        tmpDateFilters[workflowfilter[1].c] = {
                            "from": null,
                            "to": null
                        };
                    }
                    if (workflowfilter[1].o === ">=") {
                        tmpDateFilters[workflowfilter[1].c].from = workflowfilter[1].v;
                    } else {
                        tmpDateFilters[workflowfilter[1].c].to = workflowfilter[1].v;
                    }
                }
            });
            // Set mocking filters
            if (mock_name && mock_value) {
                tmpFilters[mock_name] = [mock_value];
            }

            Object.keys({...tmpFilters, ...tmpDateFilters}).forEach(tmpKey => {
                const tmpValues = tmpFilters[tmpKey];
                // Now filter our data
                result = result.filter(item => {
                    // Copied from verkoopshop
                    for (const b of item.extra.workflowproperties) {
                        if (b.field.name === tmpKey) {
                            if (Object.keys(tmpDateFilters).includes(tmpKey)) {
                                let valid = true;
                                if (tmpDateFilters[tmpKey].from && b.value < tmpDateFilters[tmpKey].from) {
                                    valid = false;
                                }
                                if (tmpDateFilters[tmpKey].to && b.value > tmpDateFilters[tmpKey].to) {
                                    valid = false;
                                }
                                return valid;
                            } else if (tmpValues.includes(b.value)) {
                                return true;
                            } else if ((typeof b.value === "string") && !b.value.startsWith("[")) {
                                return tmpValues.some(r => `${r}` === `${b.value}`);
                            } else if ((typeof b.value === "string") && b.value.startsWith("[")) {
                                let tmpArray = JSON.parse(b.value);
                                return tmpValues.some(r => tmpArray.includes(r));
                            } else if (Array.isArray(b.value)) {
                                return tmpValues.some(r => b.value.includes(r));
                            }
                        }
                    }

                    return false;
                });
            });

            return result;
        };

        watch(
            () => [generalFilters.workflowrefine, componentData.workflowrefines, appData.cardsbyphase],
            () => {
                if (!componentData.workflowrefines_init) return;

                // NOTE not the best code at all, resolving the propertyfilter shouldn't be needed actually but was since output from API isn't passing it.
                // NOTE also it might by only needed to check when dropdown is open instead, no need for check when closed.

                const workflowphaseIds = getWorkflowphasesByBoardId(workflowboard_id.value)?.map(a => a.id) ?? [];
                const tmpData = [];
                workflowphaseIds.forEach(workflowphase_id => {
                    tmpData.push(...(appData.cardsbyphase[workflowphase_id] ?? []));
                });

                // componentData.workflowrefines.forEach((workflowrefine) => {
                //     const workflowpropertyfield = workflowrefine?.extra?.workflowpropertyfield;
                //     const workflowpropertyValue = ""
                //     if (!workflowpropertyfield) return;
                //     // Skip DateField
                //     if (workflowpropertyfield.type === "DateField") return;
                //     // Reset totals then calculate them
                //     componentData.totals[workflowpropertyfield.id] = {};
                //     workflowrefine.extra?.options?.forEach(option => {
                //         componentData.totals[workflowpropertyfield.id][option.id] = filter(tmpData, workflowpropertyfield.name, option.id).length;
                //     });
                // });
            },
            {
                immediate: true,
                deep: true
            }
        );


        const total = (target) => {
            return computed(
                () => {
                    if (!target) return 0;
                    return Object.values(target).reduce((ac, cv) => {
                        return ac + cv;
                    }, 0);
                }
            ).value
        };

        const handleDateFilter = (name, item) => {
            setTimeout(() => {
                const input = document.querySelector(`input[name="${name}"]`);
                if (!input) return;
                filterValues[name] = [input.value];
                handleFilter();
            }, 500);
        };


        watch(
            () => generalFilters.workflowrefine,
            (filters) => {
                if (!filters || !appData.predefined_init) return;
                // Based on selected filters set url
                const filterObject = filters.map(filter => {
                    if (filter[1].o === ">=") {
                        return {
                            [`${filter[1].c}_from`] : filter[1].v
                        };
                    } else if (filter[1].o === "<=") {
                        return {
                            [`${filter[1].c}_to`] : filter[1].v
                        };
                    }
                    return {
                        [filter[1].c] : Array.isArray(filter[1].v) ? filter[1].v.join(",") : filter[1].v
                    };
                }).reduce((a, b) => {
                    return {...a, ...b};
                }, {});
                router.push({ path: route.path, query: {...filterObject}})
            }
        );

        const value = (item, operator) => {
            return computed(() => {
                const workflowpropertyfield = item?.extra?.workflowpropertyfield;


                const selected_filter = generalFilters.workflowrefine.find(filter => {
                    return filter[1].c === workflowpropertyfield.name && filter[1].o === operator;
                });
                if (selected_filter && selected_filter[1]?.v) {
                    return selected_filter[1].v;
                }

                return "";
            }).value;
        };

        const checked = (item, option) => {
            return computed(() => {
                const selectedValues = filterValues[item.workflowpropertyfield_id] ?? [];
                if (Array.isArray(selectedValues)) {
                    if (selectedValues.map(a => `${a}`).includes(`${option.id}`)) {
                        return true;
                    }
                } else {
                    if (`${selectedValues}` === `${option.id}`) {
                        return true;
                    }
                }
                return false;
            }).value;
        };
        const hasChecked = (item) => {
            return computed(() => {
                // console.log("filterValues",filterValues);
                const selectedValues = filterValues[item.workflowpropertyfield_id] ?? [];
                if (Array.isArray(selectedValues)) {
                    return selectedValues.length > 0;
                } else {
                    return !!selectedValues;
                }
            }).value;
        };

        const handleClick = (e, item, option) => {
            if (checked(item, option)) {
                e.preventDefault();
                // console.log("Currently checked", filterValues);
                if (Array.isArray(filterValues[item.workflowpropertyfield_id])) {
                    filterValues[item.workflowpropertyfield_id] = filterValues[item.workflowpropertyfield_id].filter(a => `${a}` !== `${option.id}`);
                } else {
                    filterValues[item.workflowpropertyfield_id] = "";
                }
            }
        };



        const initPredefined = () => {
            // console.log("componentData.workflowrefines.length",componentData.workflowrefines, componentData.workflowrefines.length);
            if (!componentData.workflowrefines.length) {
                appData.predefined_init = true;
                return;
            }

            const newFilters = [];
            componentData.workflowrefines.forEach(workflowrefine => {
                const workflowpropertyfield = workflowrefine?.extra?.workflowpropertyfield;
                let name = workflowpropertyfield?.name;
                [name, `${name}_from`, `${name}_to`].forEach(key => {
                    if (workflowpropertyfield && getQuery(key)) {
                        const values = getQuery(key)?.split(",").filter(a => a !== "");
                        if (values.length) {
                            newFilters.push(defineFilter(workflowpropertyfield, values, key));
                            filterValues[workflowpropertyfield?.id] = Array.isArray(values) && (values.length < 2) ? values[0] : values;
                        }
                    }
                });
            });
            generalFilters.workflowrefine = newFilters;
            setTimeout(() => {
                appData.predefined_init = true;
            }, 250);
        };


        let formValueWatcher;

        const debouncedHandleFilter = debounce(() => {
            handleFilter();
            setTimeout(() => {
                activeDropdown.value = null;
            }, 100);
        }, 200);

        onMounted(() => {
            appData.predefined_init = false;

            watch(
                () => workflowboard_id.value,
                (id) => {
                    generalFilters.workflowrefine = [];
                    appData.predefined_init = false;
                    if (!id) {
                        componentData.workflowrefines_init = true;
                        appData.predefined_init = true;
                        return;
                    }

                    const tmpObject = {
                        "workflowrefines": []
                    };
                    getDataWithoutLimit(`${apiHostname}${config.value.workflowrefine.url}`, [
                        [

                            "FieldFilter",
                            {
                                "column": "state",
                                "value": "Online"
                            }
                        ],
                        [
                            "RelatedFilter",
                            {
                                "linked_ids": [id],
                                "match_all": false,
                                "module": "Workflowboard",
                                "module_link": "Workflowrefine"
                            }
                        ]
                    ], tmpObject, "workflowrefines").then((response) => {
                        componentData.workflowrefines = tmpObject.workflowrefines;
                        componentData.workflowrefines_init = true;

                        componentData.workflowrefines.forEach(item => {
                            const fieldId = item.workflowpropertyfield_id;
                            if (!(fieldId in filterValues)) {
                                filterValues[fieldId] = [];
                            }
                        });

                        initPredefined();

                        formValueWatcher = watch(
                            filterValues,
                            () => debouncedHandleFilter(),
                            { deep: true }
                        );
                    });
                },
                {
                    immediate: true
                }
            );
        });
        onUnmounted(() => {
            appData.predefined_init = false;

            formValueWatcher && formValueWatcher();
        });


        const resetSearch = () => {
            visualSearch.value = "";
        };
        const visualFilter = (values) => {
            return computed(() => {
                return values.filter((value) => {
                    if (typeof value?.label !== "string") return false;
                    return value.label.toLowerCase().includes(visualSearch.value.toLowerCase());
                });
            }).value;
        };

        const resetSelection = (item) => {
            if (!item) return;
            filterValues[item.workflowpropertyfield_id] = "";
        };


        const workflowrefines = computed(() => {
            return componentData.workflowrefines.filter(a => {
                if ((a.extra?.workflowpropertyfield?.name === env("company_property_name")) && company_id.value) {
                    return false;
                }
                return true;
            });
        });

        return {
            trans,
            componentData,
            filterValues,

            dropdownRefs,
            isDropdownActive,
            handleDropdownClick,

            formRef,
            handleFilter,
            handleDateFilter,

            inputType,
            total,

            value,
            checked,
            hasChecked,
            handleClick,

            visualSearch,
            visualFilter,
            searchInputRef,
            resetSearch,

            resetSelection,

            workflowrefines
        };
    },
});
</script>

<style>
.iframe-container {
    max-height:calc((100vh - (var(--padding-large) * 2) - 20px)); overflow-y:auto;
}
</style>
<script setup lang="ts">
</script>